import React, { useState } from 'react';
import Table from 'react-bootstrap/Table';
import TaskGroupHeader from './TaskGroupHeader';
import ContentPlannerTable from './ContentPlannerTable';
import TableHead from 'Components/TableHeader/TableHead';
import Styles from './TaskGroup.module.scss';

function TaskGroup({
  group,
  onDelete,
  onEdit,
  onMove,
  fetchCPTasks,
  onArchive,
  onUpdateBrief,
  selectedColumns,
  calendarTable,
  handleAICreate,
  defaultExpanded = false,
  showCheckbox,
  selectedTaskIds,
  onTaskSelect,
  sortRef,
  initialSortColumn,
  initialSortDirection,
  // TableHead props
  updateColumns,
  TableHeadings,
  onSort,
  currentSort,
  onSelectAll,
  isAllSelected,
  isIndeterminate,
  viewMode = 'general', // View mode to determine group type label
}) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  // Map view mode to group type label
  const getGroupTypeLabel = () => {
    const typeLabels = {
      status: 'Status',
      brand: 'Brand',
      assignee: 'Assignee',
      contentType: 'Content Type',
      deadline: 'Deadline',
      campaign: 'Campaign',
    };
    return typeLabels[viewMode] || 'Status';
  };

  return (
    <div className={Styles.taskGroup}>
      <TaskGroupHeader
        label={group.label}
        count={group.count}
        color={group.color}
        bgColor={group.bgColor}
        isExpanded={isExpanded}
        onToggle={handleToggle}
        groupType={getGroupTypeLabel()}
      />

      {isExpanded && (
        <div className={Styles.groupContent}>
          {group.tasks.length > 0 ? (
            <Table className="table-auto" hover responsive="lg">
              <TableHead
                selectedColumns={selectedColumns}
                updateColumns={updateColumns}
                TableHeadings={TableHeadings}
                onSort={onSort}
                currentSort={currentSort}
                showCheckbox={showCheckbox}
                onSelectAll={onSelectAll}
                isAllSelected={isAllSelected}
                isIndeterminate={isIndeterminate}
              />
              <ContentPlannerTable
                tasks={group.tasks}
                onDelete={onDelete}
                onMove={onMove}
                onEdit={onEdit}
                fetchCPTasks={fetchCPTasks}
                onArchive={onArchive}
                onUpdateBrief={onUpdateBrief}
                selectedColumns={selectedColumns}
                calendarTable={calendarTable}
                handleAICreate={handleAICreate}
                showCheckbox={showCheckbox}
                selectedTaskIds={selectedTaskIds}
                onTaskSelect={onTaskSelect}
                sortRef={sortRef}
                initialSortColumn={initialSortColumn}
                initialSortDirection={initialSortDirection}
              />
            </Table>
          ) : (
            <div className={Styles.emptyState}>
              <p className={Styles.emptyMessage}>{group.emptyMessage}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// Memoize TaskGroup to prevent unnecessary re-renders
// Only re-render if group data or selected tasks change
export default React.memo(TaskGroup, (prevProps, nextProps) => {
  return (
    prevProps.group.label === nextProps.group.label &&
    prevProps.group.count === nextProps.group.count &&
    prevProps.group.tasks.length === nextProps.group.tasks.length &&
    prevProps.selectedTaskIds === nextProps.selectedTaskIds &&
    prevProps.isAllSelected === nextProps.isAllSelected &&
    prevProps.isIndeterminate === nextProps.isIndeterminate &&
    prevProps.selectedColumns === nextProps.selectedColumns
  );
});
